import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class EmailNewsletterMarketing extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Email Newsletter Marketing"
					title={"email newsletter marketing"}
					image={require('./image-6.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Email Newsletter Marketing
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							

								<p>A lot of businesses think email marketing is old news - this couldn’t be further from the truth! 
Email marketing gives you the chance to stay in the forefront of your customers mind, creates a solid marketing and remarketing list, and generates communication between your brand and your stakeholders. We call this ‘retention’ marketing, rather than ‘acquisition’ marketing, meaning it’s easier to sell to an existing customer rather than find a new one.</p>

								<h4>The Moshi Moshi marketeers are email marketing masters.</h4>
								
     
    <p>We can set up a new email account for your business using your existing <a href="https://www.moshi.com.au/whatwedo/domain-address-registration">domain</a>,  create easy to edit templates for your newsletters via Mailchimp, and can even help you out with <a href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">content</a> ideas. Emailing your database is a surefire way to stay relevant and front of mind - it could also be the factor that gets that sale over the line. 
</p>
<p>You also have the option of auto-populating your newsletters with content from your website or blog pages, which are scheduled regularly to be sent out. 

</p>
<a href="https://www.moshi.com.au/what-weve-done/mens-health-wa"><img src={require('./mens.png')} style={{padding: 30}} height="375" width="350" alt="Men's Health Newsletter Template" className="align-centre" align="centre" /></a>
<a href="https://www.moshi.com.au/what-weve-done/bunbury-runners-club"><img src={require('./BRC.png')} style={{padding: 30}} height="375" width="350" alt="Bunbury Runner's Club Email Template" className="align-centre" align="centre" /></a>
<a href="https://www.moshi.com.au/what-weve-done/prince-hotel"><img src={require('./Prince-news.png')} style={{padding: 30}} height="375" width="350" alt="Prince of Wales Email Newsletter" className="align-centre" align="centre" /></a>
<br></br>
<hr></hr>
<h2>Related Services</h2>

<a class="btn" href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Website and Newsletter Content Writing</a>       
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/domain-address-registration">Domain Address Registration</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>
		
		
		
		

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>

<h4>Email newsletter setups can be a pain if you’re not 100% sure what you’re doing.</h4>
<h3> Save yourself the hassle and get it done right the first time with Moshi. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default EmailNewsletterMarketing;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/EmailNewsletterMarketing.js